export default "__VITE_ASSET__CT$Xt9Gg__"